export default class ValidationUtils {
  static validateEmail(email: string): boolean {
    // eslint-disable-next-line
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  static validAxxessPassword(str = ''): boolean {
    var pattern = new RegExp(/^(?=.*[a-zA-Z])(?=.*[0-9])(?=.{8,}).*$/);
    return pattern.test(str);
  }

  static validWebsite(str = ''): boolean {
    try {
      const urlRegex = new RegExp(
        /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/
      );
      return urlRegex.test(str);
    } catch (err) {
      return false;
    }
  }

  static validPhoneNumber(str: string): boolean {
    // expected: '+X XXX XXX-XXXX'
    return !!(str && str.length === 15);
  }

  static validZipCode(str: string): boolean {
    return !!(str && str.length === 5);
  }

  static validMerchantID(str: string): boolean {
    return !!(str && str.length > 4);
  }
  static validateName(name: string): boolean {
    // eslint-disable-next-line
    const re = /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/;
    return re.test(String(name));
  }
}
